import {
  GET_PORTAL_AUDIT_LOGS_FAIL,
  GET_PORTAL_AUDIT_LOGS_REQUEST,
  GET_PORTAL_AUDIT_LOGS_SUCCESS,
} from "../constants/adminPortal_portalAuditLogsConstants";

export const getPortalAuditLogsReducer = (state = { portalAuditLogs: [] }, action) => {
  switch (action.type) {
    case GET_PORTAL_AUDIT_LOGS_REQUEST:
      return { ...state, loading: true };
    case GET_PORTAL_AUDIT_LOGS_SUCCESS:
      return { ...state, loading: false, portalAuditLogs: action.payload };
    case GET_PORTAL_AUDIT_LOGS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
